import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import CreditCardForm from '@/components/credit-cards/CreditCardForm.vue';
    import type { SharedData } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCreditCard',
  setup(__props) {

    const { t } = useI18n();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        name: '',
        number: '',
        type: '',
        last_used: '',
        employee_ids: [],
        user_ids: [],
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.credit-cards.store', { company: selectedCompanyId.value }),
    "query-key": ['credit-cards'],
    title: "credit-cards.create.title",
    "button-text": "credit-cards.create.title",
    "success-message-translated": _unref(t)('credit-cards.create.success', { name: _unref(form).name }),
    transform: 
            (data) => ({
                ...data,
                number: data.number.replace(/\s/g, ''),
            })
        
  }, {
    default: _withCtx(() => [
      _createVNode(CreditCardForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "success-message-translated", "transform"]))
}
}

})